/* Allsupletion en Shopify (Claude Code, 2026-10-05).
   Lo que la web original no necesitaba y Shopify sí:
   · enlaces .html de la web → direcciones de Shopify
   · botón "Agregar" → carrito real de Shopify
   · filtros y orden del catálogo sobre las tarjetas que pinta Liquid
   · el editor de Shopify recarga secciones sin recargar la página: se re-activan */
(function () {
  if (window.ASTienda) return;
  var T = (window.ASTienda = {});
  var POL = { envios: 'shipping-policy', reembolso: 'refund-policy', privacidad: 'privacy-policy', terminos: 'terms-of-service', contacto: 'contact-information' };

  function reescribe(h) {
    if (!h) return h;
    var m = h.match(/^(?:\.\/)?([a-z0-9-]+\.html)(\?[^#]*)?(#.*)?$/i);
    if (!m) return h;
    var pag = m[1], q = new URLSearchParams(m[2] || ''), ancla = (m[3] || '').slice(1);
    if (pag === 'politicas.html') return '/policies/' + (POL[ancla] || 'shipping-policy');
    if (pag === 'producto.html') {
      var id = q.get('id'), u = q.get('u');
      var handle = AS.productos && AS.productos[id];
      if (handle) return '/products/' + handle + (u ? '?u=' + u : '');
      return (AS.links['productos.html'] || '/collections/all');
    }
    if (pag === 'productos.html') {
      var base = AS.links['productos.html'] || '/collections/all';
      return base + (m[2] || '') + (m[3] || '');
    }
    var dest = AS.links[pag];
    return dest ? dest + (m[3] || '') : h;
  }
  T.links = function (raiz) {
    (raiz || document).querySelectorAll('a[href$=".html"], a[href*=".html?"], a[href*=".html#"]').forEach(function (a) {
      var h = a.getAttribute('href'), r = reescribe(h);
      if (r !== h) a.setAttribute('href', r);
    });
    if (typeof muyPronto === 'function') muyPronto(raiz);
  };

  function contador(n) {
    document.querySelectorAll('.cart-count').forEach(function (c) { c.textContent = n; c.hidden = !n; });
  }
  /* Los productos del kit salen de la sección "Kit: ofertas y pedido" (ID de Dropi de cada uno, editable
     en Shopify). cant = cuántos lleva el pack elegido: los primeros de la lista. */
  T.pedirKit = function (cant) {
    var ids = [].map.call(document.querySelectorAll('[data-kit-dropi]'), function (e) { return +e.dataset.kitDropi; }).slice(0, cant || 3);
    var items = ids.map(function (d) { return { id: +(AS.variantes && AS.variantes[d]), quantity: 1 }; });
    if (!items.length || items.some(function (i) { return !i.id; })) { if (typeof toast === 'function') toast((window.AS && window.AS.avisos && window.AS.avisos.kit_no_disponible) || 'Este kit aún no está disponible. Vuelve en unos días.'); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return T.descuentos(); })
      .then(function () { location.href = '/cart'; })
      .catch(function (e) { if (typeof toast === 'function') toast((e && e.description) || (window.AS && window.AS.avisos && window.AS.avisos.kit_error) || 'No se pudo armar el kit. Intenta de nuevo.'); });
  };

  /* [2026-10-05] Precios de pack, kit y premio del juego en el carrito real. Shopify cobra cada
     unidad a su precio; los códigos de assets/as-codigos.js (creados en Shopify con el monto exacto)
     bajan el total al precio que muestra la ficha. Se eligen según lo que hay en el carrito. */
  T.codigosPara = function (cart) {
    var C = window.AS && AS.codigos;
    if (!C) return [];
    var ahora = Date.now(), cyber = ahora < Date.parse(C.hasta);
    var porVariante = {};
    Object.keys(AS.variantes || {}).forEach(function (d) { porVariante[AS.variantes[d]] = d; });
    var cant = {};
    cart.items.forEach(function (it) {
      var d = porVariante[it.variant_id];
      if (d) cant[d] = (cant[d] || 0) + it.quantity;
    });
    var pct = 0;
    try {
      if (localStorage.getItem('as-disc') === '1' && ahora < +(localStorage.getItem('as-disc-hasta') || 0)) pct = +(localStorage.getItem('as-disc-pct') || 10);
    } catch (e) { /* sin almacenamiento */ }
    var codigos = [], usados = {};
    /* Kits: si están sus productos, va el precio del kit (el de 3 antes que el de 2). */
    Object.keys(C.kitIds).forEach(function (k) {
      var ids = C.kitIds[k].map(String);
      [3, 2].some(function (q) {
        var ps = ids.slice(0, q);
        if (!ps.every(function (d) { return cant[d] > 0 && !usados[d]; })) return false;
        var opc = C.kits.filter(function (x) { return x.k === k && x.q === q; });
        var kit = opc.filter(function (x) { return x.f === (cyber ? 'C' : 'N'); })[0] || opc.filter(function (x) { return x.f === 'N'; })[0];
        if (!kit) return false;
        codigos.push(kit.code);
        ps.forEach(function (d) { usados[d] = 1; });
        return true;
      });
    });
    /* Packs: 2 unidades, o 3 o más, del mismo producto. */
    Object.keys(cant).forEach(function (d) {
      if (usados[d] || cant[d] < 2) return;
      var p = C.productos[d];
      if (!p) return;
      var f = (cyber && p.C) ? p.C : p.N;
      if (!f) return;
      var q = cant[d] >= 3 ? 3 : 2;
      var cod = (pct && f[q + 'j' + pct]) || f[String(q)];
      if (cod) codigos.push(cod);
    });
    return codigos;
  };
  /* Deja en el carrito los códigos que corresponden. Devuelve true si cambió algo. */
  T.descuentos = function () {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var quiero = T.codigosPara(cart).sort();
      var tiene = (cart.discount_codes || []).map(function (c) { return c.code; }).sort();
      if (quiero.join(',') === tiene.join(',')) return false;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: quiero.join(',') }) }).then(function () { return true; });
    }).catch(function () { return false; });
  };

  T.agregar = function (id, cantidad, boton) {
    if (!id) return;
    if (boton) boton.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: cantidad || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return T.descuentos(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) {
        contador(c.item_count);
        if (typeof toast === 'function') toast((window.AS && window.AS.avisos && window.AS.avisos.agregado) || 'Agregado al carrito ✓');
      })
      .catch(function (e) { if (typeof toast === 'function') toast((e && e.description) || (window.AS && window.AS.avisos && window.AS.avisos.error_agregar) || 'No se pudo agregar. Intenta de nuevo.'); })
      .finally(function () { if (boton) boton.disabled = false; });
  };

  T.catalogos = function (raiz) {
    (raiz || document).querySelectorAll('[data-as-catalogo]').forEach(function (el) {
      if (el.dataset.asInit) return;
      el.dataset.asInit = '1';
      var grid = el.querySelector('.p-grid');
      var tarjetas = [].slice.call(grid.querySelectorAll('.p-card'));
      var cuenta = el.querySelector('.cat-count');
      var mas = el.querySelector('.cat-more');
      var preview = +el.dataset.preview || 0;
      var p = new URLSearchParams(location.search);
      var st = { cat: p.get('cat') || 'todos', sex: (p.get('sexo') || 'todos').toLowerCase(), sort: 'rec', all: !preview };
      if (!el.querySelector('[data-cat="' + st.cat + '"]')) st.cat = 'todos';
      function dibuja() {
        var lista = tarjetas.filter(function (t) {
          var tg = t.dataset.tags;
          var okCat = st.cat === 'todos' || tg.indexOf('|' + st.cat + '|') > -1;
          var okSex = st.sex === 'todos' || tg.indexOf('|sexo:' + st.sex + '|') > -1 || tg.indexOf('|sexo:a|') > -1;
          return okCat && okSex;
        });
        var num = function (t, k) { return +t.dataset[k]; };
        if (st.sort === 'rec') lista.sort(function (a, b) { return num(a, 'orden') - num(b, 'orden'); });
        if (st.sort === 'asc') lista.sort(function (a, b) { return num(a, 'precio') - num(b, 'precio'); });
        if (st.sort === 'desc') lista.sort(function (a, b) { return num(b, 'precio') - num(a, 'precio'); });
        if (st.sort === 'az') lista.sort(function (a, b) { return a.dataset.nombre.localeCompare(b.dataset.nombre, 'es'); });
        var vis = st.all ? lista : lista.slice(0, preview);
        tarjetas.forEach(function (t) { t.hidden = true; });
        vis.forEach(function (t) { t.hidden = false; grid.appendChild(t); });
        var vacio = grid.querySelector('.cat-empty');
        if (vacio) vacio.hidden = !!vis.length;
        /* Las palabras salen de la sección del catálogo (editables en Shopify); [n] = la cantidad. */
        var tc = el.dataset.txtCuenta || '[n] productos', tv = el.dataset.txtVer || 'Ver los [n] productos';
        if (cuenta) cuenta.textContent = tc.replace('[n]', lista.length);
        if (mas) mas.innerHTML = vis.length < lista.length ? '<button type="button" class="btn btn-ghost" data-more>' + tv.replace('[n]', lista.length) + ' <span data-ic="arrow"></span></button>' : '';
        if (mas && typeof ic === 'function') mas.querySelectorAll('[data-ic]').forEach(function (s) { s.innerHTML = ic(s.dataset.ic); });
        el.querySelectorAll('[data-cat]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.cat === st.cat); });
        el.querySelectorAll('[data-sex]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.sex === st.sex); });
      }
      el.addEventListener('click', function (e) {
        var c = e.target.closest('[data-cat]'), s = e.target.closest('[data-sex]'), m = e.target.closest('[data-more]');
        if (c) st.cat = c.dataset.cat;
        if (s) st.sex = s.dataset.sex;
        if (m) st.all = true;
        if (c || s || m) dibuja();
      });
      var orden = el.querySelector('[data-sort]');
      if (orden) orden.addEventListener('change', function (e) { st.sort = e.target.value; dibuja(); });
      dibuja();
    });
  };

  function iconos(raiz) {
    if (typeof ic !== 'function') return;
    raiz.querySelectorAll('[data-ic]').forEach(function (el) { if (!el.querySelector('svg')) el.insertAdjacentHTML('afterbegin', ic(el.dataset.ic)); });
    raiz.querySelectorAll('.stars:empty').forEach(function (el) { el.innerHTML = ic('star').repeat(5); });
  }

  T.init = function () {
    T.links();
    T.catalogos();
    contador(AS.carrito || 0);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add]');
      if (b) { e.preventDefault(); T.agregar(b.dataset.add, +(b.dataset.cantidad || 1), b); }
      var c = e.target.closest('[data-cart]');
      if (c && !b) {
        e.preventDefault();
        if (c.classList.contains('icon-btn')) { location.href = '/cart'; return; }
        var caja = c.closest('.p-card[id^="p"]');
        var pid = caja ? caja.id.slice(1) : (window.AS && AS.productoId);
        var linea = (caja || c.closest('.pd-info') || document).querySelector('[data-disc-price]');
        var cant = linea ? (+linea.dataset.unidades || 1) : 1;
        var v = pid && AS.variantes && AS.variantes[pid];
        if (v) T.agregar(v, cant, c);
        else if (typeof toast === 'function') toast((window.AS && window.AS.avisos && window.AS.avisos.no_disponible) || 'Este producto aún no está disponible.');
      }
    });
    var pend = null;
    new MutationObserver(function () {
      clearTimeout(pend);
      pend = setTimeout(function () { T.links(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });

    /* Editor de Shopify: una sección recién cambiada vuelve "cruda"; se re-activa. */
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target;
      r.querySelectorAll('[data-rv-group]').forEach(function (g) { [].forEach.call(g.children, function (c) { c.setAttribute('data-rv', ''); }); });
      iconos(r);
      var h = r.querySelector('[data-hero]');
      if (h && typeof heroSlider === 'function') heroSlider(h);
      if (r.querySelector('[data-announce]') && typeof chrome === 'function') { chrome(); if (typeof countdowns === 'function') countdowns(); iconos(document); }
      if (typeof menuTienda === 'function' && r.querySelector('#menu-tienda')) menuTienda();
      T.catalogos(r);
      T.links(r);
    });
  };
})();
